<template>
<base-layout>
    <div class="fixed-height timesheets-list-tab">
         <div style="display:none;">
                <input type="text">
                <input type="password">
            </div>
        <template v-if="!openVerifyTimesheet">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-1 pTop10" >
                        <p class="head__text">{{ timesheetLabel }}/Expenses</p>
                    </div>
                    <div class="col-md-2 pTop10" style="padding-right:0;margin-left:80px">
                        <ob-input class="search-bar" icon="fa-search" placeholder="Search..." :disabled="isLoading || !hasData "  value="searchText" v-model.trim="searchText" @keyup.native.enter="searchData" ></ob-input>
                    </div>
                    <div class="col-md-2 pTop10" style="margin-right: -35px;padding-left: 0px;">
                        <ob-button class="search-btn" :disabled="isLoading || !hasData " @click="searchData">Search</ob-button>
                        <p class="timesheet_filter"><img @click="showFilters = true" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_filter.svg`" alt="image" /></p>
                        <ob-button class="clear-btn" type="link" v-if="isFilterApplied || isSearchApplied"  @click="clearFilter" >Clear</ob-button>
                    </div>
                    <div class="col-md-4 pTop10" style="margin-right: -165px;">
                        <ob-button :disabled="disableApproveAllButton && selectedTimesheetCount <= 0" style="margin-right: 20px;" type="primary" @click="ApproveOrRejectTimesheets('Approved')">
                            <span v-if="disableApproveAllButton && (selectedTimesheetCount <= 0)" v-tooltip="`Select an employee(s) to approve ${timesheetLabel.toLowerCase()}/expenses.`">Approve</span>
                            <span v-else>Approve</span>
                        </ob-button>
                        <ob-button :disabled="disableApproveAllButton  && selectedTimesheetCount <= 0" type="secondary" @click="ApproveOrRejectTimesheets('Rejected')">
                            <span v-if="disableApproveAllButton && (selectedTimesheetCount <= 0)" v-tooltip="`Select an employee(s) to reject ${timesheetLabel.toLowerCase()}/expenses.`">Reject</span>
                            <span v-else>Reject</span>
                        </ob-button>
                    </div>
                    <div class="col-md-3 pR0" >
                        <div class="pagination" style="float: right !important;padding-right:0px;margin-right:-110px">
                            <ul  class="list-unstyled list-inline routes_ul">

                                <li  v-if="TimesheetsCount == 0" style="margin-top:5px;padding-right:0px"> <img  style="cursor:not-allowed;padding-right: 20px;" v-tooltip.top ="{content: 'Column Settings'}" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/settings.svg`" /></li>
                                <li v-else style="margin-top:5px"> <img @click="OpenColumnSettings()" style="cursor:pointer;padding-right: 0px;" v-tooltip.top ="{content: 'Column Settings'}" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/settings.svg`" /></li>

                                <li  v-if="TimesheetsCount == 0" style="margin-top:5px">  <img  style="cursor:not-allowed;margin-left: 3px;" v-tooltip.top ="{content: 'Export'}" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/export.svg`" /> <span class="vertical-line"></span></li>
                                <li  v-else style="margin-top:5px">  <img @click="OpenTimesheetExport()" style="cursor:pointer;margin-left: 3px;" v-tooltip.top ="{content: 'Export'}" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/export.svg`" /> <span class="vertical-line"></span></li>

                                <li class="pagination-count-txt" v-if="TimesheetsCount > 0">1 - {{To}} of {{TimesheetsCount}}</li>
                                <li class="pagination-count-txt" v-else >0 - 0 of 0</li>
                                <!-- <li><ob-button type="secondary" class="pagination__controls" icon="fa fa-chevron-left" @click="prevPage" :disabled="PageIndex == 0 || TimesheetsCount < PageSize || isLoading" ></ob-button></li>
                                <li><ob-button type="secondary" class="pagination__controls" icon="fa fa-chevron-right" @click="nextPage" :disabled="TimesheetsCount < PageSize || TimesheetsCount == To || isLoading" ></ob-button></li> -->
                                <li  class="legend-li" ><ob-button @click="addTimesheets()" style="width:100px" type="primary" >Add {{ timesheetLabel }}</ob-button></li>
                                <li>
                                    <div style="background: #1f2023;border-radius: 5px;height:30px;padding:3px">

                                        <ob-popover :visibleArrow="false" trigger="click" :options="{placement: 'bottom'}" ref="popover">
                                            <div class="popper popper_icon">
                                                <div class="view-options">
                                                     <p class="view-options-p" @click="routeToCalender" >Calendar View</p>
                                                    <p class="view-options-p" @click="routeToList"  v-bind:class="{'view_option' : this.$route.query.listView}">List View</p>
                                                </div>
                                            </div>
                                            <span  style="cursor: pointer;" slot="reference">
                                              <img v-if="IsClenderView" style="width:20px" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendarview.svg`"/>
                                              <img v-else  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_listview.svg`"/>
                                               <img  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_dropdown.svg`"/>
                                            </span>

                                        </ob-popover>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" style="margin-bottom:10px">
                <template v-if="filterObj != null && filterObj != '' " >
                    <span class="filter-name" v-if="filterObj.ProjectTitle != null && filterObj.ProjectTitle.id != null && filterObj.ProjectTitle.id != ''">
                        {{ filterObj.ProjectTitle.text }}
                        <span @click="removeTextFromFilter('ProjectTitle')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                    <span class="filter-name"  v-if=" filterObj.FromDate != null && filterObj.FromDate != ''">
                        {{ filterObj.FromDate }} to {{filterObj.ToDate}}
                            <span @click="removeTextFromFilter('FromDate')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                     <span  class="filter-name"  v-if="filterObj.EndClientName != null && filterObj.EndClientName.id != null && filterObj.EndClientName.id != ''">
                        {{ filterObj.EndClientName.text }}
                            <span @click="removeTextFromFilter('EndClientName')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                    <span  class="filter-name" v-if="filterObj.ClientName != null && filterObj.ClientName.id != null && filterObj.ClientName.id != ''">
                        {{ filterObj.ClientName.text }}
                        <span @click="removeTextFromFilter('ClientName')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                    <span  class="filter-name" v-if="filterObj.TimeSheetStatus != null && filterObj.TimeSheetStatus != null && filterObj.TimeSheetStatus != ''">
                        {{ filterObj.TimeSheetStatus }}
                            <span @click="removeTextFromFilter('TimeSheetStatus')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                     <span  class="filter-name" v-if="filterObj.ExpenseStatus != null && filterObj.ExpenseStatus != null && filterObj.ExpenseStatus != ''">
                        {{ filterObj.ExpenseStatus }}
                            <span @click="removeTextFromFilter('ExpenseStatus')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                    <span class="filter-name"  v-if="  filterObj.ReportingAuthority != null && filterObj.ReportingAuthority.id != null && filterObj.ReportingAuthority.id != ''">
                        {{ filterObj.ReportingAuthority.text }}
                            <span @click="removeTextFromFilter('ReportingAuthority')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                    <span  class="filter-name" v-if="filterObj.EmployeeStatus != null && filterObj.EmployeeStatus != null && filterObj.EmployeeStatus != ''">
                        {{ filterObj.EmployeeStatus }}
                            <span @click="removeTextFromFilter('EmployeeStatus')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                     <span  class="filter-name" v-if="filterObj.ProjectStatus != null && filterObj.ProjectStatus != null && filterObj.ProjectStatus != ''">
                        {{ filterObj.ProjectStatus }}
                            <span @click="removeTextFromFilter('ProjectStatus')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                      <span  class="filter-name" v-if="filterObj.TaxTerms != null && filterObj.TaxTerms != null && filterObj.TaxTerms != ''">
                        {{ filterObj.TaxTerms }}
                            <span @click="removeTextFromFilter('TaxTerms')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                     <span  class="filter-name" v-if="filterObj.EmploymentType != null && filterObj.EmploymentType != null && filterObj.EmploymentType != ''">
                        {{ filterObj.ProjectStatus }}
                            <span @click="removeTextFromFilter('EmploymentType')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                     <span  class="filter-name" v-if="filterObj.BillingStatus != null && filterObj.BillingStatus != null && filterObj.BillingStatus != ''">
                        {{ filterObj.BillingStatus }}
                            <span @click="removeTextFromFilter('BillingStatus')" class="cross-mark" style="font-size: 11px; " >&#10006;</span>
                    </span>
                </template>
                </div>
                <div class="sidenav" v-if="showTimesheetExport">
                    <div class="sideNavHeader">
                            <h3 class="header-items">Export </h3>
                    </div>
                    <p class="export-text">Export the required columns in CSV format</p>
                    <div class="fixed-scroll">
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.Name">FULL NAME</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.Type">Type</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.DateRange">DATE RANGE</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.ProjectTitle">PROJECT TITLE</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.ClientOrganizationName">CLIENT ORGANIZATION NAME</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.ClientContactName">CLIENT CONTACT NAME</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.EndClient">END-CLIENT</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.SubmittedOn">SUBMITTED ON	</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.ApprovedOn">APPROVED ON</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.ApprovedBy">APPROVED By</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.TotalHours">TOTAL HOURS WORKED</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.TotalExpenses">TOTAL EXPENSE(S)</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.Status">STATUS</ob-checkbox>
                        <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.InvoiceStatus">INVOICE STATUS</ob-checkbox>
                        <!-- <ob-checkbox :val="1" class="checkbox-style" v-model="ExportList.AttachmentUrls">ATTACHMENTS</ob-checkbox> -->

                    </div>
                    <span class="ob-vuelidate_error-msg" v-if="!validationMessage">Please select atleast one columns</span>
                        <div class="dashed-line"></div>
                    <div class="exempt-list-footer">
                        <ob-button type="secondary" width="80px;" @click="cancelExport()">Cancel</ob-button>
                        <ob-button type="primary"  :disabled="!validationMessage" width="80px;" @click="Export()">Export</ob-button>

                    </div>
                </div>
                <div class="sidenav" v-if="showColumnSettings"><!--https://github.com/andynoir/vuetify-table-drag/blob/master/src/views/PageTable/PageTable.vue -->
                    <div class="sideNavHeader">
                        <h3 class="header-items">Column Settings</h3>
                    </div>
                    <p class="export-text">To change the column order, drag and drop a field</p>

                    <div class="fixed-scroll">
                        <table style="width:100%">
                                <tr><div style="float: right;padding-right:7px;padding-top:5px;"><a @click="restoreDefaultSettings()" style="color: #707070"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/refresh.svg`" style="padding-right:5px"><span style="font-weight:600;font-size:11px">Restore Default</span></a></div></tr>
                            <template>
                                <draggable :list="ColumnSettingsList"  tag="tbody" >

                                        <tr  v-for="(user, index) in ColumnSettingsList"   :key="index">
                                            <td v-if="user.ColumnType == 'Name'" v-tooltip="'You cannot uncheck &quot;Full Name&quot; column as it is a primary field'" class="shadow" style="cursor: move;display: flex;"><img style="padding-left:10px;padding-top: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/ic_drag_indicator.svg`" /><div><ob-checkbox :val="1" :disabled="true"  class="checkbox-style" style="margin-left:25px" v-model="user.IsEnabled">{{user.DisplayName}}</ob-checkbox></div></td>
                                            <td v-else class="shadow" style="cursor: move;display: flex;"><img style="padding-left:10px;padding-top: 2px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/table/ic_drag_indicator.svg`" /><div><ob-checkbox :val="1"   class="checkbox-style" style="margin-left:25px" v-model="user.IsEnabled">{{user.DisplayName}}</ob-checkbox></div></td>
                                            </tr>
                                    </draggable>
                                    </template>
                            </table>

                    </div>
                    <div class="dashed-line"></div>
                    <div class="exempt-list-footer">
                        <ob-button type="secondary" width="80px;" @click="cancelColumnSettings()">Cancel</ob-button>
                        <ob-button type="primary" width="80px;" @click="saveColumnSettings()">Apply</ob-button>
                    </div>
                </div>

                 <div class="col-md-12">
                        <div v-if="selectedTimesheetCount > 0 || IsSelecteAll" class="selection-holder">
                            {{selectedTimesheetCount}} {{SelectedRecordType}}(s) selected.
                            <a v-if="!IsSelecteAll" @click="clearSelection">(Clear)</a>
                            <a  v-if="IsSelecteAll" @click="clearSelection" style="text-decoration:underline">Clear selection</a>
                            <a v-if="!IsSelecteAll">. <span style="text-decoration:underline" @click="selectAllTimesheets()">{{SelectAllText}}</span></a>
                        </div>
                    </div>
                </div>
            <ob-table  type="selection" :style="getTableHeight" ref="timesheetsTable" :fixed-body="tableHeight"
                :table-header="completeTableHeader"
                :is-loading="isLoading"
                :table-data="timesheetsList"
                :isSelectAll ="isHeaderCheckBox"
                :config="config"
                :isRowClickable= true
                :showAvailableCheckBox = true
                :noResultsObj="noResults"
                :isHeaderCheckBoxDisabled="disableHeaderCheckBox"
                @loadmore="loadtableData" :lazyLoading="lazyLoadingObj"
                @selectionChange="handleSelectionChange"
                @sortChange="handleSortChange">
                           <template v-for="(item, tdIndex) in timesheetsList">
                                <template v-for="th in completeTableHeader">
                                    <template :slot="`m-slot-${th.key}-${tdIndex}`">
                                            <template v-if="th.key == 'Attachments'">
                                                 <template v-if="item.AttachmentUrls.length > 1">
                                                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                                                        <div class="popper popper_attachment">
                                                            <template v-for="(item, index) in item.AttachmentUrls">
                                                                <div class="popper_attachment_text" @click="openAttachment(item)">
                                                                <div class="col-md-10  pL0">
                                                                    {{getFileName(item)}}
                                                                </div>
                                                                    <div class="col-md-2  pL0">
                                                                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_newtab-link.svg`" class="att-img-cls"/>
                                                                </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                        <p slot="reference">
                                                            <a> {{getPopoverContent(item)}} </a>
                                                        </p>
                                                    </ob-popover>
                                            </template>
                                            <template v-else-if="item.AttachmentUrls.length == 1">
                                                <a @click="openAttachment(item.AttachmentUrls[0])"  class="popper_attachment_text">
                                                    {{getFileName(item.AttachmentUrls[0])}}
                                                </a>
                                            </template>
                                            <template v-else>
                                                <p>N/A</p>
                                            </template>
                                            </template>
                                    </template>
                                </template>
                    </template>


                    <template slot="th">
                        <!-- <th v-if="showAttachments"><span class="cell-data" style="min-width: 200px;">ATTACHMENTS</span></th> -->
                        <th><span class="cell-data">ACTIONS</span></th>
                    </template>
                    <template v-for="(item, index) in timesheetsList" :slot="`td${item[config.primaryKey]}${index}`">
                        <!-- <td  v-if="showAttachments" :key="`ATTACHMENTS${item[config.primaryKey]}`" style="min-width: 200px;">
                            <template v-if="item.AttachmentUrls.length > 1">
                                    <ob-popover trigger="click" :options="{placement: 'bottom'}">
                                        <div class="popper popper_attachment">
                                            <template v-for="(item, index) in item.AttachmentUrls">
                                                <div class="popper_attachment_text" @click="openAttachment(item)">
                                                <div class="col-md-10  pL0">
                                                    {{getFileName(item)}}
                                                </div>
                                                    <div class="col-md-2  pL0">
                                                    <img src="/static/Images/ic_newtab-link.svg" class="att-img-cls"/>
                                                </div>
                                                </div>
                                            </template>
                                        </div>
                                        <p slot="reference">
                                            <a> {{getPopoverContent(item)}} </a>
                                        </p>
                                    </ob-popover>
                            </template>
                            <template v-else-if="item.AttachmentUrls.length == 1">
                                <a @click="openAttachment(item.AttachmentUrls[0])"  class="popper_attachment_text">
                                    {{getFileName(item.AttachmentUrls[0])}}
                                </a>
                            </template>
                            <template v-else>
                                <p>N/A</p>
                            </template>

                        </td> -->
                        <td :key="`actions${item[config.primaryKey]}`">
                            <ob-dropdown title="Actions" class="js-stop-propagate-class">
                                <template v-if="item.InvoiceStatus == 'Invoice Generated'">
                                    <ob-dropdown-list-item @click.native="TimesheetReport(item)">View Report</ob-dropdown-list-item>
                                </template>
                                <template v-else-if="item.Status == 'Approved'">
                                    <!-- <ob-dropdown-list-item v-if="!IsQBTokenExpired" @click.native="onGenerateInvoiceActionClick(item)">Generate Invoice</ob-dropdown-list-item> -->
                                    <ob-dropdown-list-item @click.native="VerifyTimesheets(item)">Edit</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="TimesheetReport(item)">View Report</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="TimesheetDelete(item)">Delete</ob-dropdown-list-item>

                                </template>
                                <template v-else-if="item.Status == 'Pending'">
                                    <ob-dropdown-list-item @click.native="VerifyTimesheets(item)">Verify</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="ApproveTimesheets(item)">Approve</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="RejectTimesheets(item)">Reject</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="TimesheetDelete(item)">Delete</ob-dropdown-list-item>

                                </template>
                                <template v-else-if="item.Status == 'Rejected'">
                                    <ob-dropdown-list-item @click.native="VerifyTimesheets(item)">Edit</ob-dropdown-list-item>
                                    <ob-dropdown-list-item @click.native="TimesheetDelete(item)">Delete</ob-dropdown-list-item>

                                </template>
                            </ob-dropdown>
                        </td>
                    </template>
            </ob-table >

            <time-sheets-filter :from="'list_view'" v-if="showFilters"  @cancel="cancelFilter"></time-sheets-filter>

            <edit-Invoice-details :missingInvoiceDetails ="MissingInvoiceDetails"  :selectedTimeIds.sync="SelectedTimesheets" :showModal.sync="showEditInvoicePopup"></edit-Invoice-details>

             <ob-modal2 :show.sync="showInvoiceProceedPopup" :type="1" :backdrop="false">
                <div style="padding:30px 15px;text-align:center">
                    <img style="width:45px;padding-bottom:10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info_blue_icon.svg`" />
                    <p style="font-size: 20px;font-weight: 600; margin: 10px;">This {{ timesheetLabel }}(s) information will be sent to
                        QuickBooks for invoice generation.
                    </p>

                </div>
                <div style="padding: 0px 20px 20px 20px;text-align:center;">
                    <ob-checkbox>Don’t show this message again</ob-checkbox>
                    <ob-button style="margin-top: 15px;" type="secondary" @click="showInvoiceProceedPopup = false">Close</ob-button>
                    <ob-button style="width: 115px; margin-top: 15px;" @click="onProceedClick()">Proceed</ob-button>
                </div>
            </ob-modal2>

             <ob-modal2 :show.sync="showInvoiceWaitPopup" :type="1" :backdrop="false">
                <div style="padding:30px 15px;text-align:center">
                    <img style="width:45px;padding-bottom:10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info_blue_icon.svg`" />
                    <p style="font-size: 20px;font-weight: 600; margin: 10px;">Please wait for a moment while we generate
                                                      your invoice(s)
                    </p>

                </div>
                <div style="padding: 0px 20px 20px 20px;text-align:center;">
                   <p>Please don’t go back or close the browser</p>
                </div>
            </ob-modal2>

             <ob-modal2 :show.sync="showInvoiceSuccesPopup" :type="1" :backdrop="false">
                <div style="padding:30px 15px;text-align:center">
                    <img style="width:45px;padding-bottom:10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info_blue_icon.svg`" />
                    <p style="font-size: 20px;font-weight: 600; margin: 10px;">
                     Invoice(s) is generated successfully
                    </p>

                </div>
                <div style="padding: 0px 20px 20px 20px;text-align:center;">
                    <ob-button  style="margin-top: 15px;" type="secondary" @click="showInvoiceSuccesPopup = false">Close</ob-button>
                   <ob-button style="width: 115px; margin-top: 15px;" @click="onInvoiceViewClick()">View</ob-button>
                </div>
            </ob-modal2>


             <ob-modal2 :show.sync="showInvoiceErrorPopup" :type="1" :backdrop="false">
                <div style="padding:30px 15px;text-align:center">
                    <img style="width:45px;padding-bottom:10px;" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/icons/info_red_icon.svg`" />
                    <p style="font-size: 20px;font-weight: 600; margin: 10px;">
                    Invoice(s) cannot be generated due to an error.
                    Please try again.
                    </p>

                </div>
                <div style="padding: 0px 20px 20px 20px;text-align:center;">
                    <ob-button  style="margin-top: 15px;" type="secondary" @click="showInvoiceErrorPopup = false">Cancel</ob-button>
                   <ob-button style="width: 115px; margin-top: 15px;" @click="generateInvoiceButtonClick();showInvoiceErrorPopup = false">Try again</ob-button>
                </div>
            </ob-modal2>
        </template>
        <template v-else>
            <employer-editTimesheet :selectedReport.sync="selectedEventInfo" :timesheetEmployeeId="TimesheetEmployeeId" :TimesheetId="selectedEventInfo.Id" :fromTab="'ListView'" :TimesheetOrExpense="TimesheetOrExpense"></employer-editTimesheet>
        </template>
        <reject-timesheet :openRejectPopup.sync="openRejectPopup" :selectedReport.sync="selectedEventInfo" :fromTab="'ListView'" :SubmitType="SubmitType"></reject-timesheet>
        <delete-timesheet :openDeletetimesheetPopup.sync="openDeleteTimesheetPopup" @Delete="DeleteTimesheetM" :type="DeleteType"></delete-timesheet>
    </div>
    </base-layout>
</template>
<script>
import RejectTimeSheet from '../Timesheets/RejectTimeSheet.vue' //'../../RejectTimeSheet.vue'
import DeleteTimesheet from './Calender/DeleteTimesheetPopup.vue'
import EditInvoiceDetails from './EditInvoiceDetails.vue'
import EmployerEditTimesheet from "./Calender/ApprovalFlow/EmployerEditTimesheet.vue";
import TimeSheetsFilter from './TimeSheetsFilter.vue'//Vue\Src\Components\Timesheets\Calender\ApprovalFlow\EmployerEditExpanses.vue
import c from 'Vue/Core/constants.js'
import utils from "Vue/Core/utils.js";
export default {
     data() {
        return {
            DeleteTimesheet:{},
            DtimesheetId:'',
            DeleteType:'',
            openDeleteTimesheetPopup:false,
            ApproveExpenseCount : 0,
            PendingExpenseCount : 0,
            SelectedRecordType:'',
            showTimesheetExport:false,
            ColumnSettingsList:[],
            backUpColSettings :[],
            showColumnSettings:false,
            completeTableHeader:[],
            ExportList:{
               Name : true,
               DateRange:true,
               ProjectTitle:true,
               ClientOrganizationName:true,
               ClientContactName:true,
               EndClient:true,
               SubmittedOn:true,
               ApprovedOn:true,
               TotalHours:true,
               TotalExpenses:true,
               Status:true,
               InvoiceStatus:true,
               AttachmentUrls:true,
               ApprovedBy:true,
               Type:true,
            },
            isHeaderCheckBox : false,
            openRejectPopup:false,
            ApprovedTimesheetCount:0,
            PendingTimesheetCount:0,
            SelectedTimesheetStatus:'',
            SelectedItem:[],

            disableApproveAllButton:true,
            disableGenerateInvoiceButton:true,
            MissingInvoiceDetails:[],
            TimesheetGlobalObjectList:[],
            showEditInvoicePopup:false,
            statusCount:0,

            IsSelecteAll:false,

            filterObj:{},
            showInvoiceErrorPopup:false,
            showInvoiceSuccesPopup:false,
            showInvoiceWaitPopup:false,
            showInvoiceProceedPopup:false,
            disableHeaderCheckBox:true,
            isHeaderCheckBoxChecked:false,
            openVerifyTimesheet:false,
            TimesheetId:'',
            TimesheetEmployeeId:'',
            selectedEventInfo:[],
            isFilterApplied:false,
            IsClenderView:false,
            isSearchApplied: false,
            SelectedTimesheets:[],
            unSeletedTimeSheets:[],
            PageIndex: 0,
            PageSize: 20,
            searchText:'',
            showFilters:false,
            hasRestriction:false,
            TimesheetsCount:0,

            TimesheetsSortType:'SubmittedDate',
            IsAscending:false,

            NameOrder   :'',
            ProjectTitleOrder   :'',
            ClientOrganizationNameOrder   :'',
            ClientNameOrder   :'',
            EndClientNameOrder   :'',
            SubmittedOnOrder   :'',
            ApprovedOnOrder   :'',
            TotalHoursOrder   :'',
            TotalExpensesOrder   :'',
            TimesheetStatusOrder   :'',


            timesheetsList:[],
              config: {
                primaryKey: "Id",
                SortType: "SubmittedOn",
                IsAscending: false,
                fixedCols: {
                    left: 0,
                    right: 0
                }
            },
            isLoading:false,
            lazyLoadingObj:{
                hasLoadMore:true,
                isLoading:false
                },
            tableHeader: [
                {
                    key: "Name",
                    name: "FULL NAME",
                    sortable: "Name",
                    slot:true,
                     transform: (o) => {
                        if (o.Name != null && o.Name != '')
                            return `<a href="ReportingEmployees/employee-evaluation-trainee?EmployeeId=${o.EmployeeId}">${o.Name}</a>`
                        else
                            return 'N/A'
                    },
                    tooltip: (o) => {
                        if(o.Name != '' && o.Name != null)
                            return o.Name
                    },
                    tdstyle: 'min-width: 200px;cursor:pointer;max-width: 200px;line-height: 31px;color: #337ab7;',
                },
                {
                    key: "DateRange",
                    name: "DATE RANGE",
                    transform: (o) => {
                        if (o.DateRange != null && o.DateRange != null)
                            return o.DateRange //moment(o.FromDate).format('MM-DD-YYYY') +' to ' + moment(o.ToDate).format('MM-DD-YYYY')
                        else
                            return 'N/A'
                    },
                    tdstyle: 'max-width: 220px;min-width: 220px;',
                },
                {
                    key: "ProjectTitle",
                    name: "PROJECT TITLE",
                    sortable: "ProjectTitle",
                    tdstyle: 'max-width: 220px;min-width: 220px;',
                    transform: (o) => {
                        if (o.ProjectTitle != null && o.ProjectTitle != '')
                            return o.ProjectTitle
                        else
                            return 'N/A'
                    },
                     tooltip: (o) => {
                        if (o.ProjectTitle != null && o.ProjectTitle != '')
                            return o.ProjectTitle
                    },
                },
                 {
                    key: "ClientOrganizationName",
                    name: "CLIENT ORGANIZATION NAME",
                    sortable: "ClientOrganizationName",
                    tdstyle: 'max-width: 220px;min-width: 220px;',
                    transform: (o) => {
                        if (o.ClientOrganizationName != null && o.ClientOrganizationName != '')
                            return o.ClientOrganizationName
                        else
                            return 'N/A'
                    },
                    tooltip: (o) => {
                        if (o.ClientOrganizationName != null && o.ClientOrganizationName != '')
                            return o.ClientOrganizationName
                        else
                            return 'N/A'
                    }
                },
                 {
                    key: "ClientContactName",
                    name: "CLIENT CONTACT NAME",
                    sortable: "ClientContactName",
                    tdstyle: 'max-width: 220px;min-width: 220px;',
                    transform: (o) => {
                        if (o.ClientContactName != null && o.ClientContactName.trim() != '')
                            return o.ClientContactName
                        else
                            return 'N/A'
                    },
                    tooltip: (o) => {
                        if (o.ClientContactName != null && o.ClientContactName.trim() != '')
                            return o.ClientContactName
                        else
                            return 'N/A'
                    }
                },
                {
                    key: "EndClient",
                    name: "END-CLIENT",
                    sortable: "EndClient",
                    tdstyle: 'max-width: 220px;min-width: 220px;',
                    transform: (o) => {
                        if (o.EndClient != null && o.EndClient != '')
                            return o.EndClient
                        else
                            return 'N/A'
                    },
                    tooltip: (o) => {
                        if (o.ClientContactName != null && o.ClientContactName.trim() != '')
                            return o.ClientContactName
                        else
                            return 'N/A'
                    }
                },
                 {
                    key: "SubmittedOn",
                    name: "SUBMITTED ON",
                    sortable: "SubmittedOn",
                    tdstyle: 'max-width: 140px;min-width: 140px;',
                    transform: (o) => {
                        if (o.SubmittedOn != null && o.SubmittedOn != '')
                            return o.SubmittedOn
                        else
                            return 'N/A'
                    }
                },
                 {
                    key: "ApprovedOn",
                    name: "APPROVED ON",
                    sortable: "ApprovedOn",
                    tdstyle: 'max-width: 140px;min-width: 140px;',
                    transform: (o) => {
                        if (o.ApprovedOn != null && o.ApprovedOn != '')
                            return o.ApprovedOn
                        else
                            return 'N/A'
                    }
                },
                 {
                    key: "TotalHours",
                    name: "TOTAL HOURS WORKED",
                    tdstyle: 'max-width: 170px;min-width: 170px;',
                    transform: (o) => {
                        if (o.TotalHours != null && o.TotalHours != '' && o.TotalHours != '0h')
                            return o.TotalHours
                        else
                            return 'N/A'
                    }
                },
                 {
                    key: "TotalExpenses",
                    name: "TOTAL EXPENSE(S)",
                    tdstyle: 'max-width: 140px;min-width: 140px;',
                    transform: (o) => {
                        if (o.TotalExpenses != null && o.TotalExpenses != '')
                            return o.TotalExpenses
                        else
                            return 'N/A'
                    }
                },
                 {
                    key: "Status",
                    name: "STATUS",
                    tdstyle: 'max-width: 100px;min-width: 100px;',
                    transform: (o) => {
                        if (o.Status != null && o.Status != '')
                            return o.Status
                        else
                            return 'N/A'
                    }
                },
                ,
                {
                    key: "Attachments",
                    name: "ATTACHMENTS",
                    tdstyle: 'max-width: 205px;min-width: 205px;',
                    slot:true,
                },
                // {
                //     key: "InvoiceStatus",
                //     name: "INVOICE STATUS",
                //     tdstyle: 'max-width: 130px;min-width: 100px;',
                //     transform: (o) => {
                //         if (o.InvoiceStatus != null && o.InvoiceStatus != '')
                //             return o.InvoiceStatus;
                //         else
                //             return 'N/A'
                //     }
                // },
                {
                    key: "ApprovedBy",
                    name: "APPROVED BY",
                    sortable: "ApprovedBy",
                    tdstyle: 'max-width: 140px;min-width: 140px;',
                    transform: (o) => {
                        if (o.ApprovedBy != null && o.ApprovedBy != '')
                            return o.ApprovedBy
                        else
                            return 'N/A'
                    }
                },
                {
                    key: "Type",
                    name: "Type",
                    tdstyle: 'max-width: 100px;min-width: 100px;',
                    transform: (o) => {
                        if (o.Type != null && o.Type != '')
                            return o.Type
                        else
                            return 'N/A'
                    }
                }
            ],
            TimesheetOrExpense:'timesheet',
            SubmitType:'TimesheetOnly',
        }
     },
     computed:{
           validationMessage()
           {
              if( this.ExportList.Name == true ||
               this.ExportList.DateRange == true ||
               this.ExportList.ProjectTitle == true ||
               this.ExportList.ClientOrganizationName == true ||
               this.ExportList.ClientContactName == true ||
               this.ExportList.EndClient == true ||
               this.ExportList.SubmittedOn == true ||
               this.ExportList.ApprovedOn == true ||
               this.ExportList.TotalHours == true ||
               this.ExportList.TotalExpenses == true ||
               this.ExportList.Status == true ||
               this.ExportList.InvoiceStatus == true||
               this.ExportList.ApprovedBy == true||
               this.ExportList.Type == true
               )
               {
                   return true
               }
               return false

           },
            showAttachments()
            {
               var index = this.ColumnSettingsList.findIndex(x=>x.ColumnType == 'Attachments')
               if(index > -1)
               {
                   return true
               }
               return false
            },
            noResults() {
                if(this.isFilterApplied || this.isSearchApplied)
                {

                }
                else
                {
                    var obj = {
                        text: `${this.timesheetLabel} added by employees will be displayed here.`,
                        imgPath: " ",
                        hideTableHeader: false
                    }
                    return obj;
                }
            },
           getTableHeight()
            {
                if(this.isFilterApplied)
                {
                    if(this.selectedTimesheetCount > 0 || this.IsSelecteAll)
                    {
                       return 'height: 79.5% !important'
                    }
                    else
                    {
                        return 'height: 82.5% !important'
                    }
                }
                else
                {
                    if(this.selectedTimesheetCount > 0 || this.IsSelecteAll)
                    {
                    return 'height: 82.5% !important'
                    }
                    else
                    {
                        return 'height: 88% !important'
                    }
                }
                return 'height: 88% !important'
            },
            selectedTimesheetCount()
            {
                var total = 0;
                if(this.IsSelecteAll)
                {
                    var unselectedTimesheets = this.unSeletedTimeSheets;
                    if(this.SelectedRecordType == "Timesheet")
                    {
                        if(this.SelectedTimesheetStatus == 'Pending'){
                        total = this.PendingTimesheetCount - parseInt(unselectedTimesheets.length);
                        }
                        else{
                        total = this.ApprovedTimesheetCount - parseInt(unselectedTimesheets.length);
                        }
                    }
                    else if(this.SelectedRecordType == "Expense")
                    {
                        if(this.SelectedTimesheetStatus == 'Pending'){
                        total = this.PendingExpenseCount - parseInt(unselectedTimesheets.length);
                        }
                        // else{
                        // total = this.ApproveExpenseCount - parseInt(unselectedTimesheets.length);
                        // }
                    }
                }
                else
                {
                    total = this.SelectedTimesheets.length;
                }
                if(parseInt(total) <= 0)
                {
                    this.IsSelecteAll = false;
                }
                return parseInt(total);
            },
            SelectAllText()
            {
                if(this.SelectedRecordType == "Timesheet")
                {
                    if(this.SelectedTimesheetStatus == 'Pending'){
                        return  `Select All  ${this.PendingTimesheetCount} Pending ${this.SelectedRecordType}(s).`
                    }
                    else{
                        return  `Select All  ${this.ApprovedTimesheetCount} Approved ${this.SelectedRecordType}(s).`
                    }
                }
                else if(this.SelectedRecordType == "Expense")
                {
                     if(this.SelectedTimesheetStatus == 'Pending'){
                        return  `Select All  ${this.PendingExpenseCount} Pending ${this.SelectedRecordType}(s).`
                    }
                    else{
                        return  `Select All  ${this.ApproveExpenseCount} Approved ${this.SelectedRecordType}(s).`
                    }
                }
            },
            filteredParameters(){
                let val = {
                    JobId: this.$store.getters.getTimeSheetFilterValue('projectId'),
                    ClientOrganizationId: this.$store.getters.getTimeSheetFilterValue('ClientOrganizationId'),
                    EndClientOrganizationId: this.$store.getters.getTimeSheetFilterValue('EndClientOrganizationId'),
                    ReportingAuthorityId: this.$store.getters.getTimeSheetFilterValue('ReportingAuthorityId'),
                    TimeSheetStatus: this.$store.getters.getTimeSheetFilterValue('TimeSheetStatus'),
                    TimeSheetCycle: this.$store.getters.getTimeSheetFilterValue('TimeSheetCycle')
                };
                return val;
            },
            hasData(){
                if(this.isFilterApplied) {
                    return true
                } else {
                    return this.timesheetsList.length > 0
                }
           },
           From(){
                if(this.TimesheetsCount == 0){
                    return 0
                }
                else{
                    return (this.PageIndex * this.PageSize) + 1;
                }
            },
            To(){
                if(this.TimesheetsCount == 0){
                    return 0
                }
                else if(this.TimesheetsCount < this.PageSize)
                    return this.TimesheetsCount
                else {
                    let fT = (this.From + this.PageSize) - 1

                    if(fT > this.TimesheetsCount)
                        return this.TimesheetsCount
                    else
                        return fT
                }
            },
            tableHeight(){
                return "100%"
            },
     },
     created() {
        this.fetchDetails();

        bus.listen("changeTimesheetStatus", (obj) => {
          this.changeTimesheetStatusLocal(obj)
        })
     },
     destroyed() {
        //Clear filter when leaves the page
        this.$store.dispatch('resetTimeSheetFilter')
     },
     components: {
         "edit-Invoice-details":EditInvoiceDetails,
         "time-sheets-filter":TimeSheetsFilter,
         "employer-editTimesheet": EmployerEditTimesheet,
         "reject-timesheet":RejectTimeSheet,
        "delete-timesheet" : DeleteTimesheet,

     },
     methods: {
        addTimesheets() {
            this.selectAddTimesheet = true
            this.$loading({ 'loadingText': 'Loading...' })
            var routerPush = this.$router.resolve({name: `employee-addtimesheets`,query: {listView: "true",from:  'employer-timesheets'}})
            setTimeout(() => {
                this.$loading({}).close()
            }, 600)
            window.open(routerPush.href, "_self")
        },
         checkAllExportList()
            {
               var  exportList = {
                            Name : true,
                            DateRange:true,
                            ProjectTitle:true,
                            ClientOrganizationName:true,
                            ClientContactName:true,
                            EndClient:true,
                            SubmittedOn:true,
                            ApprovedOn:true,
                            TotalHours:true,
                            TotalExpenses:true,
                            Status:true,
                            InvoiceStatus:true,
                            AttachmentUrls:true,
                            ApprovedBy:true,
                            Type:true,
                        };
              this.ExportList = exportList;
            },
            OpenTimesheetExport()
            {
                this.showTimesheetExport = true;
            },
            cancelExport()
            {
               this.showTimesheetExport = false;
               this.checkAllExportList();
            },
            Export()
            {
                this.showTimesheetExport = false;
                var array=[]
                if(this.ExportList.Name == true)
                    array.push("Name")
                if(this.ExportList.DateRange == true)
                    array.push("DateRange")
                if(this.ExportList.ProjectTitle == true)
                    array.push("ProjectTitle")
                if(this.ExportList.ClientOrganizationName == true)
                    array.push("ClientOrganizationName")
                if(this.ExportList.ClientContactName == true)
                    array.push("ClientContactName")
                if(this.ExportList.EndClient == true)
                    array.push("EndClient")
                if(this.ExportList.SubmittedOn == true)
                    array.push("SubmittedOn")
                if(this.ExportList.ApprovedOn == true)
                    array.push("ApprovedOn")
                if(this.ExportList.TotalHours == true)
                    array.push("TotalHours")
                if(this.ExportList.TotalExpenses == true)
                    array.push("TotalExpenses")
                if(this.ExportList.Status == true)
                    array.push("TimesheetStatus")
                if(this.ExportList.InvoiceStatus == true)
                    array.push("InvoiceStatus")
                if(this.ExportList.AttachmentUrls == true)
                    array.push("AttachmentUrls")
                if(this.ExportList.ApprovedBy == true)
                    array.push("ApprovedBy")
                if(this.ExportList.Type == true)
                    array.push("Type")
                var reqObj ={
                    "filter": this.filterObject(),
                    "Columns": array
                }
                this.showExportList = false
                this.$loading({ 'loadingText': 'Loading...' })
                ajax.post(`TimeSheets/ExportTimesheetsToCSV`, reqObj,(res) => {
                    this.$loading({}).close()
                    try{
                        if(res && res.data != null && res.data != ''&&res.data.State){
                            if(res.data != "No Data supplied."){
                                let documentUrl = res.data.ReportUrl;
                                let link = documentUrl + "&download=true";
                                utils.GenerateFileURL(link).then((url) => {
                                    window.open(url, '_blank')
                                });
                            }
                            else{
                                this.$message({
                                    type: "error",
                                    message: res.data
                                });
                            }
                        }
                        else{
                            this.$message({
                                type: "error",
                                message: "Failed to export"
                            });
                        }
                        this.checkAllExportList()
                    }catch(ex){
                        //Console.log(ex)
                    }
                })
            },
            restoreDefaultSettings(){
                this.isLoading = true;
                 this.cancelColumnSettings();
                ajax.get(`Table/RestoreDefaultTableSettings?tableType=Timesheets&tabType=`, {}, (res) => {
                  if(res.data.State){
                    this.$message({
                        type: "success",
                        message:res.data.Message
                    });
                    this.reLoadData();
                }else{

                }
                this.isLoading = false
                })

            },

        saveColumnSettings()
        {
            this.isLoading = true
            this.ColumnSettingsList.forEach((colVal,cIndex) => {
                  this.$set(colVal,'Order',cIndex+1)
            })

            var obj=  {
                    "tabType":null,
                    "tableType":"Timesheets",
                    "tableSettings": this.ColumnSettingsList,
            }
            ajax.post(`Table/UpdateTableCustomSettings`, obj, (res) => {
                if(res.data.State){
                  this.reLoadData();
                  this.cancelColumnSettings();
                }else{
                     this.$loading({}).close()
                    this.isLoading = false
                }

            })
        },
        OpenColumnSettings(){
            this.ColumnSettingsList =  JSON.parse(JSON.stringify( this.backUpColSettings ));
            this.showColumnSettings = true
        },
        cancelColumnSettings(){
            this.ColumnSettingsList = []
            this.showColumnSettings = false
        },
        setTableHeader(){
                this.completeTableHeader = []

                this.ColumnSettingsList.forEach((colSet,cIndex) =>{
                    this.tableHeader.forEach((gridH,gIndex) =>{
                          if(colSet.ColumnType == gridH.key ){
                              if(colSet.IsEnabled)
                              this.completeTableHeader.push(gridH)
                          }
                      })
                })
        },
        reLoadData()
        {
           this.openVerifyTimesheet = false;
           this.openRejectPopup = false;
           this.timesheetsList = [];
           let from = 0 ;
           let size = this.PageIndex * this.PageSize
           this.fetchDetails(from,size);
        },
        loadtableData()
        {
            if(!(this.TimesheetsCount < this.PageSize || this.TimesheetsCount == this.To || this.isLoading))
            {
                this.PageIndex = (this.PageIndex + 1);
                this.fetchDetails();
            }
        },
        onGenerateInvoiceActionClick(item)
        {
            var x = item;
            var list = [];
            var ids = [];
            list.push(x);
            ids.push(x.TimesheetId)
            this.SelectedTimesheets =  ids;

            if(this.QBAccountDetails.ShowInvoiceGenerationPopup)
            {
                this.showInvoiceProceedPopup = true;
            }
            else{
                this.getMissingInvoiceDetails();
            }
        },
        generateInvoiceButtonClick()
        {
            if(this.QBAccountDetails.ShowInvoiceGenerationPopup)
            {
                this.showInvoiceProceedPopup = true;
            }
            else{
                this.getMissingInvoiceDetails();
            }
        },
        onProceedClick()
        {   // if check box clicked true // need to call API
            this.getMissingInvoiceDetails();
        },
        getMissingInvoiceDetails()
        {
            this.$loading({'loadingText': 'Loading...'});
            var ids = [];
            if(this.IsSelecteAll)
            {
              ids = this.unSeletedTimeSheets
            }
            else
            {
              ids = this.SelectedTimesheets
            }
            var Obj = {
                timesheetIds: ids,
                isSelectAll: this.isSelectAll,
                isSelectAll:this.IsSelecteAll,
                filter:this.filterObject(),
                count:this.selectedTimesheetCount
            };
           ajax.put(`TimeSheets/GetMissingInvoiceDetails`, Obj, res => {
                this.$loading({}).close();
                this.showInvoiceProceedPopup = false;
                if (res.data.State == true) {
                    if(res.data.Count > 0)
                    {
                    this.MissingInvoiceDetails  =  res.data.TimesheetList;
                    this.showEditInvoicePopup = true;
                    }
                    else{
                        var invoiceDetails = [];
                        this.generateInvoice(invoiceDetails)
                    }
                }
                else if (res.data.State == false) {
                this.$message({
                    type: "error",
                    message: res.data.Message
                });
                }
            });
        },
        generateInvoice(invoiceDetails)
        {
            this.showEditInvoicePopup = false;
            var objList = []
            if(invoiceDetails != null)
            {
                invoiceDetails.forEach(function(item) {
                    var obj = {
                                ContactName:item.InvoiceContactName,
                                ContactEmailId :item.InvoiceContactEmailId,
                                ContactPhoneNumber :item.InvoiceContactPhoneNumber,
                                IsSameAsClientContact :item.InvoiceIsSameAsClientContact,
                                BillRate :item.BillRate,
                                ProjectId:item.ProjectId
                            }
                        objList.push(obj)
                });
            }
            this.showInvoiceWaitPopup = true;
            var Obj =   {
                TimesheetIds :this.SelectedTimesheets,
                missingInvoiceDetailsModel:objList

            }
            ajax.put(`qbapi/quickbooks/invoice/generate`, Obj, res => {
                  this.showInvoiceWaitPopup = false;
                if (res.data == 'success') {
                    this.$message({
                        type: "success",
                        message: "Invoice generated Succesfully"
                    });
                    this.reLoadData();

                } else{
                    this.$message({
                        type: "error",
                        message: res.data
                    });
                    if(res.data.Status == 'QBNOTCONFIGURED')
                    {
                        this.$router.push({path: 'admin-settings/qb-login'}) // need to redirect to Login page with form fields
                    }
                    else if(res.data.Status == 'REFRESHTOKENEXPIRED')
                    {
                        this.$router.push({path: 'admin-settings/qb-login'}) // need to redirect to Login page
                    }
                    else
                    {
                         this.showInvoiceErrorPopup = true;
                    }
                }
            });
           // this.showInvoiceProceedPopup = true;

        },
        getUnique(arr, comp) {
        const unique = arr
            .map(e => e[comp])
            .map((e, i, final) => final.indexOf(e) === i && i)
            .filter(e => arr[e]).map(e => arr[e]);
        return unique;
        },

         handleSortChange(sort){

            this.config.SortType = sort.SortType
            this.config.IsAscending = sort.IsAscending;

            this.IsAscending = sort.IsAscending;

            let isAscending = '';
            if(sort.IsAscending)
            {
                isAscending = 'ASC'
            }
            else{
                isAscending = 'DESC'
            }
            if(sort.SortType == 'Name')
            {
                this.NameOrder = isAscending;
                this.TimesheetsSortType = "EmployeeName"
            }
            else if(sort.SortType == 'ProjectTitle')
            {
                 this.ProjectTitleOrder = isAscending;
                  this.TimesheetsSortType = "ProjectName"
            }
            else if(sort.SortType == 'ClientOrganizationName')
            {
                 this.ClientOrganizationNameOrder = isAscending;
                  this.TimesheetsSortType = "ClientOrganizationName"
            }
            else if(sort.SortType == 'ClientContactName')
            {
                 this.ClientNameOrder = isAscending;
                  this.TimesheetsSortType = "ClientContactName"
            }
            else if(sort.SortType == 'EndClient')
            {
                 this.EndClientNameOrder = isAscending;
                  this.TimesheetsSortType = "EndClientOrganizationName"
            }
            else if(sort.SortType == 'SubmittedOn')
            {
                 this.SubmittedOnOrder = isAscending;
                  this.TimesheetsSortType = "SubmittedDate"
            }
            else if(sort.SortType == 'ApprovedOn')
            {
                 this.ApprovedOnOrder = isAscending;
                  this.TimesheetsSortType = "ApprovedDate"
            }
            // else if(sort.SortType == 'ApprovedBy')
            // {
            //      this.ApprovedOnOrder = isAscending;
            //       this.TimesheetsSortType = "ApprovedBy"
            // }
            else if(sort.SortType == 'Type')
            {
                 this.EndClientNameOrder = isAscending;
                  this.TimesheetsSortType = "Type"
            }
            this.timesheetsList = [];

            this.fetchDetails()
        },
        TimesheetReport(item)
        {
            var rType = ''
            if(item.Type == "Expense"){
                rType = 'ExpenseReport'
            }else{
               rType = 'TimesheetReport'
            }
            this.$loading({'loadingText': 'Loading...'})
            ajax.get(`TimeSheets/TimesheetReport/${item.Id}?employeeId=${item.EmployeeId}&Rtype=${rType}`,{},(res) => {
            if(res.data.State == true){


                    window.open(res.data.ReportUrl, "_blank");

                    this.$loading({}).close();
                }else{
                this.$loading({}).close();
                this.$message({
                    type:'error',
                    message: res.data.Message
                })
                }
            })
        },
        clearSelection()
        {
            this.isHeaderCheckBox = false;
            this.IsSelecteAll = false,
            this.SelectedTimesheets = [];
            this.SelectedTimesheetStatus = '';

            this.disableHeaderCheckBox = true;
            this.disableApproveAllButton = true;
            this.disableGenerateInvoiceButton = true;

            this.timesheetsList.forEach((f)=>{
                if(f.InvoiceStatus == "Invoice Generated" || (( f.ProjectTitle == "" || f.ProjectTitle == null) && f.Status == 'Approved') || (f.Type == 'Expense' && f.Status == 'Approved'))
                {
                    f.showCheckBox = false;
                }
                else{
                    f.showCheckBox = true;
                }
                f.isChecked = false
            })
        },
        selectAllTimesheets()
        {
            this.IsSelecteAll = true;
            let status = this.SelectedTimesheetStatus;
            this.unSeletedTimeSheets = [];

            for(var i = 0 ; i < this.timesheetsList.length ; i++)
            {
                if(this.timesheetsList[i].Status == status && this.timesheetsList[i].showCheckBox )
                {
                    this.timesheetsList[i].isChecked = true
                }
            }

        },
        changeTimesheetStatusLocal(obj)
        {
            this.statusCount ++;

            for(var j= 0 ; j <  this.timesheetsList.length ; j++)
            {
                if(obj.timesheetId == this.timesheetsList[j].TimesheetId)
                {
                    this.timesheetsList[j].Status = obj.status
                }
            }

            let loadingText = `${obj.status}  ${this.statusCount}  out of ${this.selectedTimesheetCount}`;

            this.$loading({'loadingText': loadingText})

            if(this.selectedTimesheetCount == this.statusCount )
            {
                  this.$loading({}).close();
                  this.$message({
                        type: "success",
                        message: `${this.timesheetLabel}(s) ${obj.status} successfully`
                    });
                    if(obj.status == 'Rejected' )
                    {
                        this.timesheetsList = [];
                        this.fetchDetails();
                    }
                    this.clearSelection();
            }
        },
        removeTextFromFilter(filterType)
        {
            if(filterType == 'FromDate')
            {
                this.filterObj['ToDate'] = null
            }
            this.filterObj[filterType] = null

            var Obj = this.filterObj;


            var ProjectId = this.filterObj != null && this.filterObj.ProjectTitle != null  ? this.filterObj.ProjectTitle.id : '';
            var TimesheetFromDate = this.filterObj != null  ? this.filterObj.FromDate: '';
            var TimesheetToDate  = this.filterObj != null  ? this.filterObj.ToDate: '';
            var EndClientOrgName  = this.filterObj != null && this.filterObj.EndClientName != null ? this.filterObj.EndClientName.id: '';
            var ClientId  = this.filterObj != null && this.filterObj.ClientName != null ? this.filterObj.ClientName.id: '';
            var TimesheetStatus = this.filterObj != null  ? this.filterObj.TimeSheetStatus: [];
            var ReportingAuthorityId  = this.filterObj != null && this.filterObj.ReportingAuthority != null ? this.filterObj.ReportingAuthority.id: '';
            var TimeSheetCycle = '' ;
            var EmployeeStatus = this.filterObj != null  ? this.filterObj.EmployeeStatus: [];
            var BillingStatus= this.filterObj != null ? this.filterObj.BillingStatus: [];
            var ExpenseStatus=this.filterObj!=null ? this.filterObj.ExpenseStatus:[];
            var ProjectStatus = this.filterObj != null  ? this.filterObj.ProjectStatus: [];
            var TaxTerms = this.filterObj != null && this.filterObj.TaxTerms != null ? this.filterObj.TaxTerms: [];
            var EmploymentType = this.filterObj != null && this.filterObj.EmploymentType != null ? this.filterObj.EmploymentType: [];


             this.$store.commit('updateTimeSheetFilterValue', { field: 'ProjectTitle', value: ProjectId })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'TimeSheetCycle', value: TimeSheetCycle  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'ClientName', value: ClientId  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'EndClientName', value: EndClientOrgName  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'ReportingAuthority', value: ReportingAuthorityId  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'TimeSheetStatus', value: TimesheetStatus  })
             this.$store.commit("updateTimeSheetFilterValue",{filed:'ExpenseStatus',value:ExpenseStatus})
             this.$store.commit('updateTimeSheetFilterValue', { field: 'FromDate', value: TimesheetFromDate  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'ToDate', value: TimesheetToDate  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'EmployeeStatus', value: EmployeeStatus  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'BillingStatus', value: BillingStatus  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'ProjectStatus', value: ProjectStatus  })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'TaxTerms', value: TaxTerms })
             this.$store.commit('updateTimeSheetFilterValue', { field: 'EmploymentType', value: EmploymentType })
            
              if((ProjectId == '' || ProjectId == null || ProjectId == undefined )
                 && (TimeSheetCycle == '' || TimeSheetCycle == null || TimeSheetCycle == undefined)
                 && (ClientId == ''|| ClientId == null || ClientId == undefined)
                 && (EndClientOrgName == '' || EndClientOrgName == null || EndClientOrgName == undefined )
                 && (ReportingAuthorityId == ''||ReportingAuthorityId == null||ReportingAuthorityId == undefined )
                 && (TimesheetStatus == ''||TimesheetStatus == null||TimesheetStatus == undefined)
                  &&(ExpenseStatus == '' || ExpenseStatus ==null || ExpenseStatus == undefined)
                  && (TimesheetFromDate == '' || TimesheetFromDate == null || TimesheetFromDate == undefined )
                  && (TimesheetToDate == ''||TimesheetToDate == null||TimesheetToDate == undefined )
                  && (EmployeeStatus == ''||EmployeeStatus == null||EmployeeStatus == undefined )
                  && (ProjectStatus == ''||ProjectStatus == null||ProjectStatus == undefined)
                     && (TaxTerms == null || TaxTerms == undefined || TaxTerms.length == 0)
                  && (EmploymentType == null || EmploymentType == undefined || EmploymentType.length == 0)
                 && (BillingStatus == null || BillingStatus == undefined || BillingStatus.length ==0 ))
                  {
                      this.isFilterApplied = false;
                  }
                  else{
                      this.isFilterApplied = true;
                  }

             this.showFilters = false;

             this.SelectedTimesheets = [];
             this.PageIndex = 0;
             this.timesheetsList = [];
             this.fetchDetails();
        },
        onApplyFilter(obj,objNames)
        {
            this.disableHeaderCheckBox = true;
            this.filterObj = obj;
            this.SelectedTimesheets = [];
            this.PageIndex = 0;
            this.timesheetsList = [];
            this.SelectedTimesheetStatus = "";
            this.clearSelection();
            this.fetchDetails();
        },
        onInvoiceViewClick()
        {

        },
        headerCheckBoxValue(val){
            this.isHeaderCheckBoxChecked = val;
        },
        openAttachment(item)
        {
           window.open(item,"_blank")
        },
        getPopoverContent(item)
        {
           let str = 'N/A';
           if(item.AttachmentUrls.length > 1)
           {
              str = this.getFileName(item.AttachmentUrls[0]) + ' +'+ (item.AttachmentUrls.length - 1);
           }
           else if(item.AttachmentUrls.length > 0)
           {
               str = this.getFileName(item.AttachmentUrls[0]);
           }
           return str
        },
        onCloseVerifyPopup()
        {
           this.openVerifyTimesheet = false;
        },
        ApproveOrRejectTimesheets(status)
        {
           // this.selectedTimesheetCount = this.SelectedTimesheets.length;
            this.statusCount = 0 ;
            this.$loading({ loadingText: `${status} 0 out of ${this.selectedTimesheetCount}` });
            var ids = [];
            if(this.IsSelecteAll)
            {
              ids = this.unSeletedTimeSheets
            }
            else
            {
              ids = this.SelectedTimesheets
            }

            var Obj = {
                TimesheetIds: ids,
                Status: status,
                isSelectAll:this.IsSelecteAll,
                filter:this.filterObject(),
                count:this.selectedTimesheetCount,
                Type:this.SelectedRecordType
            };
           ajax.put(`TimeSheets/BulkApporoveOrRejectTimeSheets`, Obj, res => {
                this.IsSelecteAll = false;
                if (res.data.State == true) {
                   this.fetchDetails();
                }
                else if (res.data.State == false) {
                this.$loading({}).close();
                this.$message({
                    type: "error",
                    message: res.data.Message
                });
                }
            });
        },
        filter()
        {
            this.showFilters = false;
            this.isFilterApplied = true
            this.isSearchApplied = false
        },
        clearFilter(){

             this.$store.dispatch('resetTimeSheetFilter')
            this.searchText = '';
            this.isSearchApplied = false
            this.isFilterApplied=false;
            this.filterObj = null;
            this.SelectedTimesheets = [];
            this.PageIndex = 0;
            this.disableHeaderCheckBox = true;
            this.timesheetsList = [];
            this.SelectedTimesheetStatus = "";
            this.clearSelection();
            this.fetchDetails();
        },
        routeToCalender()
        {
            this.captureTimesheetCalendarViewSwitchedClick()
            this.IsClenderView = true;
            this.$router.push({'path': '/employer-timesheets'})
        },
        routeToList()
        {
            this.captureTimesheetListViewSwitchedClick()
            this.IsClenderView = false;
            this.$router.push({'path': '/timesheets-list'})
        },
        captureTimesheetCalendarViewSwitchedClick() {
            this.$posthog.capture('Timesheet Calendar View Switched', {
                pageName: 'Timesheets',

            });
        },
        captureTimesheetListViewSwitchedClick() {
            this.$posthog.capture('Timesheet List View Switched', {
                pageName: 'Timesheets',

            });

        },
        handleSelectionChange(v)
        {
            var checkedItems =  v.filter(p=>p.isChecked);

            if(checkedItems.length == 1 || this.IsSelecteAll)
            {
                var status = checkedItems.length > 0 ?  checkedItems[0].Status : '';
                var type = checkedItems.length > 0 ?  checkedItems[0].Type : '';
                if(status != null && status != '')
                {
                    this.SelectedTimesheetStatus = status;
                }
                else{
                    status = this.SelectedTimesheetStatus;
                }

                if(type != null && type != '')
                {
                  this.SelectedRecordType = type;
                }
                else
                {
                   type = this.SelectedRecordType ;
                }
                if(status == 'Approved')
                {
                    this.disableGenerateInvoiceButton = false;
                }
                else if(status == 'Pending' )
                {
                    this.disableApproveAllButton = false
                }
                this.disableHeaderCheckBox = false;
                v.forEach((e)=>{
                        if(e.InvoiceStatus == "Invoice Generated" || ((e.ProjectTitle == "" || e.ProjectTitle == null) && e.Status == 'Approved') || e.Status == 'Approved')
                        {
                            e.showCheckBox = false;
                        }
                        else if(e.Status == "Pending" && this.SelectedRecordType == e.Type){
                            e.showCheckBox = true;
                        }
                        else if(e.Status == "Rejected")
                        {
                            e.showCheckBox = false;
                        }
                        else if(e.Status == status && e.Type == type){
                            e.showCheckBox = true;
                        }
                        else{
                            e.showCheckBox = false;
                        }
                })
            }
            else if(checkedItems.length == 0)
            {
                this.disableHeaderCheckBox = true;
                this.disableApproveAllButton = true;
                this.disableGenerateInvoiceButton = true;
                if(this.SelectedTimesheetStatus != null && this.SelectedTimesheetStatus != "" && this.IsSelecteAll)
                {
                    this.disableHeaderCheckBox = false;
                    if(this.SelectedTimesheetStatus == 'Approved')
                    {
                        this.disableGenerateInvoiceButton = false;
                    }
                    else if(this.SelectedTimesheetStatus == 'Pending' )
                    {
                            this.disableApproveAllButton = false
                    }
                }
                v.forEach((e)=>{

                    if(e.InvoiceStatus == "Invoice Generated" || ((e.ProjectTitle == "" || e.ProjectTitle == null) && e.Status == 'Approved') || ( e.Status == 'Approved'))
                    {
                        e.showCheckBox = false;
                    }
                    else if(this.IsSelecteAll && e.Status == "Pending")
                    {
                        e.showCheckBox = false;
                    }
                    else if(e.Status == "Rejected")
                    {
                        e.showCheckBox = false;
                    }
                    else if(this.IsSelecteAll && e.Status == this.SelectedTimesheetStatus && e.Type == this.SelectedRecordType)
                    {
                        e.showCheckBox = false;
                    }
                    else{
                        e.showCheckBox = true;
                    }
                })
            }
            var checkedItems =  v.filter(p=>p.isChecked && p.Status == this.SelectedTimesheetStatus && this.SelectedRecordType == p.Type);
            var ids = checkedItems.map(v=>v.Id);
            let activeList = v.filter(p=>p.showCheckBox == true);
            if(checkedItems.length > 0 && checkedItems.length == activeList.length){
                this.isHeaderCheckBox = true
            }
            else{
                this.isHeaderCheckBox = false
            }
            this.SelectedTimesheets =__.uniq(ids);

            var unCheckedItems =  v.filter(p=>!p.isChecked && p.Status == this.SelectedTimesheetStatus && this.SelectedRecordType == p.Type);
            var unCheckedIds = unCheckedItems.map(v=>v.Id );
            this.unSeletedTimeSheets =__.uniq(unCheckedIds);
        },
        cancelFilter(){
            this.showFilters = false
        },
        searchData(){
            if(this.searchText && this.searchText.length > 0){
                this.isSearchApplied = true
                this.PageIndex = 0;
                this.clearSelection();
                this.timesheetsList = [];
                this.fetchDetails()
            }
        },
        filterObject()
        {
            let filterObj = {
                PageNo : this.PageIndex,
                PageSize  : this.PageSize,
                SearchText :this.searchText,
                ProjectId  :this.filterObj != null && this.filterObj.ProjectTitle != null  ? this.filterObj.ProjectTitle.id : '',
                TimesheetFromDate :this.filterObj != null  ? this.filterObj.FromDate: '',
                TimesheetToDate  :this.filterObj != null  ? this.filterObj.ToDate: '',
                EndClientOrgName  :this.filterObj != null && this.filterObj.EndClientName != null ? this.filterObj.EndClientName.id: '',
                ClientId  :this.filterObj != null && this.filterObj.ClientName != null ? this.filterObj.ClientName.id: '',
                TimesheetStatus:this.filterObj != null  ? this.filterObj.TimeSheetStatus: [],
                ExpenseStatus:this.filterObj!=null ? this.filterObj.ExpenseStatus:[],
                ReportingAuthorityId  : this.filterObj != null && this.filterObj.ReportingAuthority != null ? this.filterObj.ReportingAuthority.id: '',
                TimeSheetCycle :'',
                EmployeeStatus:this.filterObj != null  ? this.filterObj.EmployeeStatus: [],
                InvoiceStatus:this.filterObj != null && this.filterObj.InvoiceStatus != null  ? this.filterObj.InvoiceStatus: [],
                BillingStatus : this.filterObj != null ? this.filterObj.BillingStatus :[],
                ProjectStatus:this.filterObj != null  ? this.filterObj.ProjectStatus: [],
                 TaxTerms:this.filterObj != null && this.filterObj.TaxTerms != null  ? this.filterObj.TaxTerms: [],
                EmploymentType:this.filterObj != null && this.filterObj.EmploymentType != null  ? this.filterObj.EmploymentType: [],
                OrgId: this.loggedInUserObj.orgId,
                TimesheetsSortType: this.TimesheetsSortType,
                IsAscending: this.IsAscending,
            }
            return filterObj;
        },
        fetchDetails(from,size)
        {
            this.lazyLoadingObj.isLoading = true
            //this.isLoading = true;
             var filterObj = this.filterObject();
             if(from != undefined && from != null && size != undefined && size != null && size != '')
             {
                  filterObj['PageNo'] = from ;
                  filterObj['PageSize'] = size;
             }
             ajax.put(`/TimeSheets/Organization/List`,filterObj,(res) => {
                if(res.data.State)
                {
                    let _this = this;

                    this.ColumnSettingsList = res.data.columnSettings
                    this.backUpColSettings =  JSON.parse(JSON.stringify( this.ColumnSettingsList ));
                    this.showColumnSettings = false
                    this.setTableHeader()

                 res.data.TimesheetList.forEach((e)=>{
                        var attachmentUrls = [];
                        if(e.TimesheetAttachments != null && e.TimesheetAttachments.length > 0 )
                        {
                            attachmentUrls.push.apply(attachmentUrls, e.TimesheetAttachments)
                        }
                        if(e.ExpensesAttachments != null && e.ExpensesAttachments.length > 0 )
                        {
                            attachmentUrls.push.apply(attachmentUrls, e.ExpensesAttachments)
                        }
                        e.AttachmentUrls = attachmentUrls;
                        
                        if(((e.ProjectTitle == "" || e.ProjectTitle == null) && e.Status == 'Approved') || e.InvoiceStatus == "Invoice Generated" ||( _this.SelectedTimesheetStatus != null && _this.SelectedTimesheetStatus != "" && _this.SelectedTimesheetStatus != e.Status) || e.Status == "Rejected" ||  e.Status == 'Approved')
                        {
                            e.showCheckBox = false;
                        }
                        else{
                             e.showCheckBox = true;
                        }
                        if(_this.IsSelecteAll)
                        {
                            if(_this.SelectedTimesheetStatus == e.Status && e.InvoiceStatus != "Invoice Generated")
                            {
                                e.isChecked = true;
                            }
                            else{
                                 e.showCheckBox = false
                            }
                        }

                 })
                var list =  res.data.TimesheetList;

                this.ApprovedTimesheetCount = res.data.ApprovedTimesheetCount;
                this.PendingTimesheetCount = res.data.PendingTimesheetCount;

                this.ApproveExpenseCount = res.data.ApprovedExpenseCount;
                this.PendingExpenseCount = res.data.PendingExpenseCount;

                this.TimesheetsCount =  res.data.Count;
                this.timesheetsList = Object.freeze(this.timesheetsList.concat(list))
                }
                else{
                  //  this.timesheetsList = [];
                }
                setTimeout(() => {
                           this.$refs.timesheetsTable.initCompile();
                }, 300)

                this.isLoading = false;
                this.lazyLoadingObj.isLoading = false
            });
         },
        VerifyTimesheets(item)
        {
           this.TimesheetId = item.Id,
           this.TimesheetEmployeeId = item.EmployeeId,
           this.selectedEventInfo = item,
           this.openVerifyTimesheet = true;
           if(item.Type == "Expense"){
              this.TimesheetOrExpense = 'expense'
           }
           else if(item.Type == "Timesheet"){
              this.TimesheetOrExpense = 'timesheet'
           }
        },
        ApproveTimesheets(event) {
            this.$loading({ loadingText: "Loading..." });
            var Obj = {
                Id: event.Id,
                EmployeeId: event.EmployeeId,
                Type:event.Type,
            };
            ajax.put(`TimeSheets/Approve`, Obj, res => {
                if (res.data.State == true) {
                    this.$message({
                        type: "success",
                        message:event.Type== "Expense" ? "Expense(s) approved successfully" : event.Type == "Timesheet" ? `${this.timesheetLabel}(s) approved successfully`:`${this.timesheetLabel}(s) and Expense(s) approved successfully` ,
                        // message: "Timesheet(s) approved successfully"
                    });
                    this.reLoadData();
                    this.$loading({}).close();
                } else if (res.data.State == false) {
                    this.$loading({}).close();
                    this.$message({
                        type: "error",
                        message: res.data.Message
                    });
                }
            });
        },
        RejectTimesheets(item)
        {
           this.selectedEventInfo = item;
           this.openRejectPopup = true;
           if(item.Type == "Expense"){
              this.SubmitType = 'ExpenseOnly'
           }
           else if(item.Type == "Timesheet"){
              this.SubmitType = 'TimesheetOnly'
           }
        },
        TimesheetDelete(item){
            if(item != null){
                if(item.Type == "Timesheet"){
                this.DtimesheetId = item.TimesheetId 
                }
                else{
                this.DtimesheetId = item.ExpenseId
                }
                this.DeleteTimesheet = item
                this.DeleteType = item.Type
                this.openDeleteTimesheetPopup = true
            }
       },
       DeleteTimesheetM(reason, Dtype){
            if(this.DtimesheetId && this.DeleteTimesheet && this.DeleteTimesheet.EmployeeId && reason){
                this.$loading({ 'loadingText': 'Loading...' })   
                ajax.put(`TimeSheets/Delete/${this.DtimesheetId}?employeeId=${this.DeleteTimesheet.EmployeeId}&type=${Dtype}&reason=${reason}`, {}, (res) => {
                    if (res.data && res.data.State) {
                    let localEventObj = {
                        Id: this.DeleteTimesheet.Id,
                        IsPagefullLoad: true,
                        EmployeeId: this.DeleteTimesheet.EmployeeId,
                        Status: "deleted",
                        type: Dtype
                    }
                    this.reLoadData();
                   // this.refetchEvents(localEventObj)
                    this.$message({
                        type: 'success',
                        message: res.data.Message ? res.data.Message : "Deleted Successfully"
                    });
                    } 
                    else {
                    this.$message({
                        type: 'error',
                        message: res.data.Message ? res.data.Message : "Delete Failed"
                    })
                    }
                    this.$loading({}).close();
                })  
                this.openDeleteTimesheetPopup = false
            }
        },
        // generateInvoice()
        // {
        //       this.showInvoiceProceedPopup = true;
        // },
        getFileName(item)
        {
            var filename = utils.I9URL2FileName(item);
            var fileLength = filename.length
            if(fileLength > 33)
            {
              return filename.substring(0,30) + "...";
            }
            return filename
        },
        prevPage(){
            this.PageIndex = (this.PageIndex - 1)
            this.fetchDetails()

        },
        nextPage(){
            this.PageIndex = (this.PageIndex + 1)
            this.fetchDetails()
        },
     },
}
</script>
<style lang="scss" scoped>

  @import "~styles/framework/vue-utils";
    .sidenav {
        height: 82.5%;
        top: 11%;
        width: 22%;
        position: fixed;
        z-index: 1003;
        right: 0;
        background-color: #fff;
        transition: 0.5s;
        overflow-x: hidden;
        box-shadow: 0px 2px 7px 0px #999;
        border-radius: 10px;
        border-bottom: 1px solid #dfdfdf;
    }
    .sideNavHeader {
        padding-top: 7px;
        border-bottom: 1px solid #dfdfdf;
        padding-bottom: 10px;
    }
    .header-items {
        font-size: 14px;
        display: inline-block;
        padding-left: 16px;
        color: #143361;
        font-weight: 600;
    }
    .export-text{
         padding: 10px 0 0 17px !important;
    }
    .checkbox-style{
        padding:5px;
        margin-left:32px;
    }
    .dashed-line{
        border-bottom:1px solid #dfdfdf;
        padding:8px;
    }
    .exempt-list-footer{
        padding:15px;
        padding-bottom:15px;
        text-align:center;
    }
    .sidenav .closebtn {
        font-size: 20px;
        display: inline-block;
        padding-left: 74%;
        color: black;
    }
    .vertical-line{
        border-right: 1.5px solid rgb(211, 211, 211);
        padding: 4px;
        padding-left: 1px;
        margin-right:6px;
        margin-left:8px;

    }
    div.fixed-scroll{
        height: calc(80% - 41px);
        overflow: auto;
    }
   .selection-holder {
            padding: 5px;
            color: #000;
            text-align: center;
            font-weight: 600;
            background: $ob-table-selection-bar;
            margin-bottom: 2px;
        }
     .cross-mark{
        padding: 0px 3px;
        border-radius: 100%;
        cursor: pointer;
    }
    .cross-mark:hover{
            background:  #c2c2c2;
            padding: 0px 3px !important;
    }
    .filter-name{
        padding: 3px;
        border-radius: 4px;
        background: #E6E6E6;
        margin-left: 5px;
        font-size: 10px;
    }
    .att-img-cls{
        cursor: pointer;
        margin-bottom: 3px;
        display:none;
    }
    .popper_attachment{
        left: -64px !important;
        min-width: 120px !important;
        margin-top: 0px !important;
        font-size: 11px;
        font-weight: 600;
        text-align: justify;

        .popper_attachment_text:hover{
              div{
                color: #337ab7 !important;
                font-weight: 600 !important;
                cursor:pointer !important;
                .att-img-cls{
                   display:inline-block !important;
                }
              }
        }
    }
    // .popper_attachment_text:hover{
    //         color: #337ab7 !important;
    //         font-weight: 600;
    //         cursor:pointer;
    //         display:inline-block;
    // }
    // .popper_attachment_text:hover{
    //     .att-img-cls{
    //         display: inline-block;
    //     }
    // }
     .popper_icon{
        background: #1f2023;
        color: #ffffff;
        border: none;

        top: 6px !important;
       // left: -43px !important;

        -webkit-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        -moz-box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);
        box-shadow: 0px 4px 12px 0px rgba(141,146,150,0.5);

       .view-options{
          //margin:-15px;
          display: block;
          color: #ffff;
          font-weight: 600;
          font-size: 13px;
          //padding: 1px 0 5px 0px;

          .view-options-p
          {
            padding: 8px 15px;
            cursor:pointer;
            color:#f9eded;
          }
          .view-options-p:hover{
                 color: #fff !important;
                 background: #423e3e !important;
          }
        }

    }
    .view_option{
        color: #fff !important;
        background: #423e3e !important;
    }
    .timesheet_filter{
            cursor: pointer;
            display: inline-block;
            padding-left: 10px;
    }
    .pTop10{
      padding:10px
    }
    .fixed-height {
        height: 100%;
    }
    .table-fixed-height{
      height: 90% !important;
    }
    .timesheets-list-tab{
        .head__text{
          color:#174474;
          font-size: 17px;
          font-weight: 600;
        }
        background: #fff;
        ul{
            list-style-type: none;
            margin-top: 8px;
            padding: 0;
            overflow: hidden;
            li{
                float:left;
                a{
                    color: #333333;
                    font-weight: 600;
                    padding: 8% 10%;
                    font-size: 13px;
                    display: block;
                    text-align: center;
                    padding: 14px 16px;
                    text-decoration: none;
                    &.router-link-exact-active{
                        color: #174474;;
                    }
                }
                .search-input{
                    width: 100%;
                    height: 30px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    padding: 0 0 0 0px;
                }
            }
            .placement-search_details{
                float: right;
                margin: 10px 17px 0;
                min-width: 140px;
            }
        }
        .pagination-count-txt{
            color: #143361;
            font-weight: 600;
            transform: translateY(7px);
        }
        .not-active-tab{
            color:#929291 !important;
        }
        .left-section{
            height: 31px;
        }
        .left-section1{
            height: 33px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/TimesheetsListView.vue